var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.28,
    height: 62.28,
    viewBox: "0 0 62.28 62.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "done-24px",
    transform: "translate(0 -0.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    transform: "translate(0 0.439)",
    fill: "none",
    stroke: "#d12a2a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.14,
    cy: 31.14,
    r: 31.14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.14,
    cy: 31.14,
    r: 30.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(31 39.439)",
    fill: "#d12a2a",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.55,
    y: 0
  }, "!")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2bd79629.svg";
export { ForwardRef as ReactComponent };